import {
  ElectionType,
} from "@shared/clients/api.generated";


export interface ExportDataForm {
  electionType: ElectionType,
  electionIdByDate: string,
  constituencies: string,
  regions: string,
  municipalitiesFromElection: string,
  nominationDistrictsFromConstituency: string,
  municipalitiesFromRegion: string,
  electionAreas: string,
}

type NullableString = string | null | undefined;

export interface ElectionObservableParams {
  electionType: ElectionType | NullableString,
  electionIdByDate: string,
  constituencies: string,
  nominationDistrictsFromConstituency: NullableString,
  electionAreas: NullableString,
  municipalitiesFromElection: string,
  regions: string,
  municipalitiesFromRegion: NullableString
}

export const FVEVFAElections = [ ElectionType.GeneralElection, ElectionType.EuropeanParliamentElection, ElectionType.Referendum ];
